import { Legal, LegalProps } from "./legal";
import { ComponentInterfaceBaseClass } from "@att-bit/duc.utils-ts.types";
import React from 'react';

export class LegalInterface extends ComponentInterfaceBaseClass implements LegalProps {
    key;
    children;
    static initWithSanity(key, feed) {
        const t = new LegalInterface();
        t.key = key;
        t.children = feed.legalText;
        return t;
    }
    toProps(): LegalProps {
        const props = {
            key: this.key,
            children: this.children,
            className: 'mar-b-xs',
        }
        return props;
    }

    toJsx(): JSX.Element {
        return React.createElement(Legal, {
            ...this.toProps(), 
        });
    }
}